import * as Constants from 'src/constants';
import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='Ryan Hill' dateTime='2023-04-18' tag='Policy' title='Payments and Chargebacks'>
        <p>Purchasing on OneShop requires a valid payment method and delivery address on file.</p>
        <p>
          All purchases will be charged immediately to your payment method. OneShop is not liable for any overage fees
          charged by your bank.
        </p>
        <p>
          OneShop has a zero tolerance policy for chargebacks. Buyers who initiate a chargeback instead of following the{' '}
          <a style={{ color: Constants.BrandColor.Bolt }} href='/policies/buyer-protections'>
            buyer protection process
          </a>{' '}
          will immediately be banned from the platform.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
